<template>
  <div class="container" @click="flagOn">
    <section id="editContent" class="columnContainer flightinfo">
      <div class="innerColumn">
      <h1 class="contentTitle">{{locale.nav_flightinfo}}</h1>
      <AirportList
        :list="airtport"
        :locale="locale" />
      </div>
      <div class="innerSide"><div class="sideBox">
        <FlightInfoSearch
          :locale="locale" />
      </div></div>
    </section>
    <div id="setContent">
      <FlightInfoSetting
        :locale="locale" />
    </div>
  </div>
</template>

<script>
import AirportList from '@/components/FlightInfo/AirportList.vue'
import FlightInfoSetting from '@/components/FlightInfo/Setting.vue'
import FlightInfoSearch from '@/components/FlightInfo/Search.vue'

export default {
  name: 'FlightInfo',
  props: [
    'locale'
  ],
  components: {
    AirportList,
    FlightInfoSetting,
    FlightInfoSearch
  },
  computed: {
    airtport () {
      const list = this.$store.getters['flightinfo/getAirport']
      return list.sort(function (a, b) {
        return a.distanceKM < b.distanceKM ? -1 : a.distanceKM > b.distanceKM ? 1 : 0
      })
    }
  },
  created () {
    this.$store.commit('onLoading', true)
    this.$store.dispatch('flightinfo/getAirport').then(() => {
      this.$store.dispatch('flightinfo/setAirportSettingData').then((res) => {
        if (res) {
          this.$store.dispatch('flightinfo/getAirport', res.search)
        }
        this.$store.commit('onLoading', false)
      })
    })
  },
  data () {
    return {
      dirtyFlag: false
    }
  },
  methods: {
    flagOn () {
      this.dirtyFlag = true
    }
  }
}
</script>
